import {
  MESSAGE_SENDER,
  MESSAGE_TYPES,
  // BUTTON_SUB_TYPES,
  BUTTON_TYPES,
} from "./constants"

export const getDefaultMessagesByKey = (key = "web") => {
  const defaultMessgaes = {
    web: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: false,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: "",
        delay: 0,
        payload: {
          text: "Hi Jini, Your personal Virtual Assistant.",
        },
        timestamp: new Date(),
      },
      {
        cmid: "message2",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: "subscription",
        delay: 0,
        payload: {
          title: "",
          subtitle: "What can I help you with today?",
          buttons: [
            {
              type: BUTTON_TYPES.LINK,
              text: "Open your Account",
              url: "https://ekyc.tradejini.com/#onboarding",
            },
            {
              type: BUTTON_TYPES.LINK,
              text: "Login to your Account",
              url: "https://cubeplus.tradejini.com/auth/login",
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "Ask your Query",
            },
          ],
        },
        timestamp: new Date(),
      }
    ],
    android: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: false,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: "",
        delay: 0,
        payload: {
          text: "Hi Jini, Your personal Virtual Assistant.",
        },
        timestamp: new Date(),
      },
      {
        cmid: "message2",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: "subscription",
        delay: 0,
        payload: {
          title: "",
          subtitle: "What can I help you with today?",
          buttons: [
            {
              type: BUTTON_TYPES.LINK,
              text: "Open your Account",
              url: "https://ekyc.tradejini.com/#onboarding",
            },
            {
              type: BUTTON_TYPES.LINK,
              text: "Login to your Account",
              url: "https://cubeplus.tradejini.com/auth/login",
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "Ask your Query",
            },
          ],
        },
        timestamp: new Date(),
      }
    ],
  }
  return defaultMessgaes[key] || []
}
